import React from 'react'
import { PurchaseContext } from '../contexts/PurchaseContext'
import { type WebProduct } from '../../common/types/webshop.types'
import { type SerialOption } from '../../common/types/webshop.types'

type Props = {
    product: string,
    host: string,
    onChange: Function,
    defaultSerial: string
}

export default function SerialSelect(props: Props) {
    const {product, host, onChange, defaultSerial} = props
    const [{serials, login}] = React.useContext(PurchaseContext);

    //This is not typically how one would handle events in React
    //but it is necessary in order to manually dispatch a change event
    //as in changeSerialValue()
    React.useEffect(() => {
        const element = document.getElementById('serial-select');
        if (element instanceof HTMLSelectElement){
            element.addEventListener('change', handleChange);
        }
    }, [])

    React.useEffect(() => {
        const serials = fetchValidSerials();
        const serialMatch = serials.find((serial: SerialOption) => {
            return serial.serial === defaultSerial;
        });
        if (serialMatch){
            changeSerialValue(defaultSerial);
        }
    }, [defaultSerial])

    const changeSerialValue = (serial: string) => {
        const changeEvent = new Event('change');
        const element = document.getElementById('serial-select');
        if (element instanceof HTMLSelectElement){
            element.value = serial;
        }
        element.dispatchEvent(changeEvent);
    }

    const fetchValidSerials = () => {
        return Object.values(serials).filter((serial: SerialOption) => {
            if (serial.isFloating){
                return false;
            }
            let selectedHost = host;
            const hostMatch = (selectedHost == null || selectedHost.toLowerCase() === serial.host.toLowerCase());       
            if (product == 'Continuum FCP') selectedHost = 'apple';
            
            const selectedProduct = product;
            const productMatch = (selectedProduct == null || selectedProduct.toLowerCase() === serial.product.toLowerCase());
            return (hostMatch && productMatch);
        });
    }
    
    const handleChange = (event: Event) => {
        onChange(event);
    }

    const validSerials = fetchValidSerials();

    const serialOptions: React.JSX.Element[] = [];
    validSerials.forEach((serial: SerialOption) => {
        serialOptions.push((
            <option key={serial.serial}>{serial.serial}</option>
        ))
    })

    let content;
    if (!login){
        content = (
            <div>
                <span style={{color: 'red'}}>Please <a href="/account/login">Log in</a> to see your licenses.</span>
            </div>
        )
    }

    else if (validSerials.length < 1){
        content = (
            <div>
                <span style={{color: 'red'}}>No Licenses Found for this Product.</span>
                <div><span>Not seeing your serial? <a href="/support/open-a-case">Contact us.</a></span></div>
            </div>
        )
    }

    else{
        content = (
            <div className='form-group' style={{marginBottom: '8px'}}>
                <label>License</label>
                <select className="form-control" name="serial" id="serial-select">
                    <option value="">Select a Serial Number</option>
                    {serialOptions}
                </select>
                <div><span>Not seeing your serial? <a href="/support/open-a-case">Contact us.</a></span></div>
            </div>
        )
    }

    return content;
}
